import * as React from "react";

const ArrowLeft = ( {style} ) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6"
    height="10"
    fill="none"
    viewBox="0 0 6 10"
    className="arrow-transition"
    style={style}
    >
    <path
      id="arrowLeft"
      fill="rgba(181, 181, 170, 1)"
      d="M6 9.25c0 .67-.867 1.002-1.37.526L.29 5.66a.9.9 0 0 1 0-1.322L4.63.224C5.133-.252 6 .08 6 .75z"
    ></path>
  </svg>
);

export default ArrowLeft;


